import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src", "loading", "alt", "height", "width"]

type PrismicImage =
        | {
              url?: null;
              dimensions?: null;
              alt?: null;
              copyright?: null;
          }
        | {
              url: string;
              dimensions: {
                  width: number;
                  height: number;
              };
              alt?: string | null;
              copyright?: string | null;
          };

    type Props = {
        lazy?: string;
        sizes?: string;
        provider?: string;
        prismicImage?: PrismicImage;
        height?: string;
        width?: string;
    };
    
export default /*#__PURE__*/_defineComponent({
  __name: 'OptimizedImage',
  props: {
    lazy: { default: 'lazy' },
    sizes: null,
    provider: null,
    prismicImage: null,
    height: null,
    width: null
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (__props.prismicImage && __props.prismicImage.url)
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: __props.prismicImage.url,
        loading: __props.lazy,
        alt: __props.prismicImage.alt || '',
        height: __props.height || __props.prismicImage.dimensions?.height,
        width: __props.width || __props.prismicImage.dimensions?.width
      }, null, 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})